import Moment from 'moment'
import { extendMoment } from 'moment-range'

Moment.updateLocale('en', {
  week: {
    dow: 1,
  },
})

export const moment = extendMoment(Moment)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Moment/index.js